import { render, staticRenderFns } from "./GlowText.vue?vue&type=template&id=230b3ed3&"
import script from "./GlowText.vue?vue&type=script&lang=ts&"
export * from "./GlowText.vue?vue&type=script&lang=ts&"
import style0 from "./GlowText.vue?vue&type=style&index=0&id=230b3ed3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports